'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useCreateQueryStringUrl } from '@/hooks/use-create-query-string-url';
import { useAuthContext } from '@/hooks/use-auth';
import { AppShellBootSkeleton } from '@/domains/dashboard/components/app-shell-boot-skeleton';
import { useGetProjects } from '@/api/generated/projects/projects';
import { GenericErrorPage } from '@/components/errors';

export default function Layout(props: { children: React.ReactNode }) {
  const router = useRouter();
  const queryStringUrl = useCreateQueryStringUrl();
  const { isSharedLink } = useAuthContext();
  const { data, status } = useGetProjects();

  const isOnboardingCompleted = status === 'success' && (data?.projects?.length ?? 0) > 0;

  useEffect(() => {
    if (status === 'loading') {
      return;
    }

    if (isOnboardingCompleted) {
      //TODO: this timeout is a tempfix for the onboarding redirect issue
      setTimeout(
        () =>
          router.push(
            queryStringUrl({
              pathname: '/reports',
            }),
          ),
        500,
      );
    }
  }, [status, isOnboardingCompleted, queryStringUrl, router]);

  if (status === 'loading' || isOnboardingCompleted) {
    return (
      <div className="fadeIn h-screen w-full">
        <AppShellBootSkeleton isSharedLink={isSharedLink} />
      </div>
    );
  }

  if (status === 'error') {
    return <GenericErrorPage />;
  }

  return <>{props.children}</>;
}
